export default {"src":"/_next/static/media/hard-drive-download.61da3a34.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};